import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="copy-link"
export default class extends Controller {
  static targets = [ "link", "content" ]

  copy(e) {
    e.preventDefault();
    // 如果有 content target，複製 content 的文字內容；否則複製 link 的值
    if (this.hasContentTarget) {
      const content = (this.contentTarget.innerText || this.contentTarget.textContent).trim();
      navigator.clipboard.writeText(content);
      alert("已複製內容:\n" + content);
    } else if (this.hasLinkTarget) {
      const link = this.linkTarget.value;
      navigator.clipboard.writeText(link);
      alert("已複製連結:\n" + link);
    }
    return false;
  }
}